/** Slot keys must match BookingForm / seat assignment (`morning` … `night`). */
export const SLOT_KEYS = ['morning', 'afternoon', 'evening', 'night'];

export function parseFallbackProductPrice(settings) {
    const raw = settings?.productPrice;
    if (raw !== undefined && raw !== null && raw !== '') {
        const n = Number(raw);
        return Number.isFinite(n) ? n : 400;
    }
    return 400;
}

/**
 * Price for one seat row: configured slot price, else fallback `productPrice`.
 */
export function priceForSlot(slot, settings) {
    const fallback = parseFallbackProductPrice(settings);
    const map = settings?.slotPrices;
    if (!slot || !map || typeof map !== 'object') return fallback;
    const v = map[slot];
    if (v !== undefined && v !== null && v !== '') {
        const n = Number(v);
        return Number.isFinite(n) ? n : fallback;
    }
    return fallback;
}

export function sumSeatLinePrices(seats, settings) {
    if (!Array.isArray(seats)) return 0;
    return seats.reduce((sum, seat) => sum + priceForSlot(seat?.slot, settings), 0);
}
